module.exports = __webpack_public_path__ + "img/windows.e573c0cb.svg";